import { FormInstance } from "antd/es/form";
import _ from "lodash";
import React from "react";
import { IUserInfoDto } from "../../models/dto/user-info.dto";
import { IValidationData } from "../../models/dto/validation-data";
import { UserService } from "../../services/user-service";
import { KContext } from "../../shared/hoc/with-context";
import { KNavigator } from "../../shared/hoc/with-history";
import { KuikaAppManager } from "../../shared/utilty/kuika-app-manager";
import { KMainFunctions } from "../../shared/utilty/main-functions";
import { ReactSystemFunctions } from "../../shared/utilty/react-system-functions";
import { Header2_ScreenContext } from "../header2/header2-context";

declare let window: any;

export interface IHomePage_ScreenProps {
  navigator: KNavigator;
  form: FormInstance<any>;
  googleLogin: any;
  screenInputs: any;
  context: KContext;
  initialValues: any;
  children: any;
}

interface IHomePage_ScreenState {
  isSpinnerVisible: boolean;
  isPageVisible: boolean;
  isLeftMenuVisible: boolean;
  spinnerCount: number;
  selectedLanguage: string;
  isPageInitLoaded: false;
  isPageRecurringLoaded: false;
  HomePageOrderCount: any[];
  HomePageOrderCount_dummy: any[];
  HomePageTop5: any[];
  HomePageTop5_dummy: any[];
  NAVIGATE: any;
  NAVIGATE_dummy: any;
  isComp444803Visible: "visible" | "hidden";
  isComp132845Visible: "visible" | "hidden";
  isComp819692Visible: "visible" | "hidden";
  isComp149411Visible: "visible" | "hidden";
  isComp4023Visible: "visible" | "hidden";
  isComp565486Visible: "visible" | "hidden";
}

export class HomePage_ScreenBase extends React.PureComponent<
  IHomePage_ScreenProps,
  any
> {
  static contextType = Header2_ScreenContext;
  declare context: React.ContextType<typeof Header2_ScreenContext>;
  homepage_13255_value_kuikaTableRef: React.RefObject<any>;
  ml = [
    {
      Id: "70da2015-72e4-4a73-bc3e-b700175ae3a3",
      Name: "en_US",
      ShortName: "English",
      IsDefault: true,
      LanguagePhrases: [],
    },
    {
      Id: "e3876a06-664b-4778-b5b8-60555fc4142e",
      Name: "FixedValues",
      ShortName: "FixedValues",
      LanguagePhrases: [
        {
          Id: 789020,
          PropertyName: "value",
          Value: "Sipariş oluşturmak için önce bir müşteri seçin.",
        },
        { Id: 381549, PropertyName: "value", Value: "Müşteri Seç" },
        { Id: 821096, PropertyName: "value", Value: "Satış Performansı" },
        { Id: 523918, PropertyName: "label", Value: "Günlük" },
        { Id: 853005, PropertyName: "label", Value: "Aylık" },
        { Id: 87548, PropertyName: "value", Value: "Güncel Satış" },
        { Id: 720533, PropertyName: "value", Value: "245000" },
        { Id: 551523, PropertyName: "value", Value: "Hedef" },
        { Id: 927242, PropertyName: "value", Value: "300000" },
        { Id: 570233, PropertyName: "value", Value: "Gerçekleşme" },
        { Id: 488382, PropertyName: "value", Value: "82" },
        { Id: 946276, PropertyName: "value", Value: "+12" },
        { Id: 254945, PropertyName: "value", Value: "245.000 / 300.000" },
        { Id: 608193, PropertyName: "value", Value: "Günlük Sipariş" },
        { Id: 459854, PropertyName: "value", Value: "8" },
        { Id: 871778, PropertyName: "value", Value: "Sipariş Durumu" },
        { Id: 818265, PropertyName: "value", Value: "Tamamlanan" },
        { Id: 983794, PropertyName: "value", Value: "Aktif" },
        { Id: 505364, PropertyName: "value", Value: "İptal" },
        { Id: 812770, PropertyName: "value", Value: "Çok Satan Ürünler" },
        { Id: 900353, PropertyName: "value", Value: "Tümünü Gör" },
        { Id: 820957, PropertyName: "title", Value: "Title" },
        {
          Id: 117289,
          PropertyName: "value",
          Value: "[datafield:productdescription]",
        },
        { Id: 197347, PropertyName: "value", Value: "[datafield:productcode]" },
        { Id: 4023, PropertyName: "value", Value: "Stokta" },
        { Id: 565486, PropertyName: "value", Value: "Stokta Yok" },
        { Id: 768790, PropertyName: "value", Value: "[datafield:price]" },
      ],
    },
  ];
  defaultML = "en_US";

  screenHash = "";

  private _prevMasterPageInitLoaded: boolean = false;
  private _prevMasterPageRecurringLoaded: boolean = false;
  private _prevShouldTriggerPageInit: boolean = false;
  constructor(props) {
    super(props);
    this.homepage_13255_value_kuikaTableRef = React.createRef();

    this.state = {
      isSpinnerVisible: false,
      isPageVisible: false,
      isLeftMenuVisible: false,
      spinnerCount: 0,
      selectedLanguage: "",
      isPageInitLoaded: false,
      isPageRecurringLoaded: false,
      HomePageOrderCount: [],
      HomePageTop5: [],
      NAVIGATE: "",
      isComp444803Visible: "hidden",
      isComp132845Visible: "hidden",
      isComp819692Visible: "hidden",
      isComp149411Visible: "hidden",
      isComp4023Visible: "hidden",
      isComp565486Visible: "hidden",
    };

    this.CheckPageAuthorization(this.state);
  }

  async componentDidMount() {
    if (KuikaAppManager.isPageInitPrevented()) {
      KuikaAppManager.calculateAndSetBodyHeight("homepage", "header2_screen");
      return;
    }
    this.context.registerCallbackFunction(this.callCallbackFunction.bind(this));

    ReactSystemFunctions.validateToken();
    this.fillFormInitValues();
    if (false) {
      await this.HomePagePageInit();
    } else if (this.context?.isMasterPageInitLoaded) {
      this._prevMasterPageInitLoaded = true;
      await this.HomePagePageInit();
    }

    KuikaAppManager.calculateAndSetBodyHeight("homepage", "header2_screen");

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = this;
    }
  }

  componentWillUnmount() {
    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = null;
    }
  }

  CheckPageAuthorization = async (state) => {
    KuikaAppManager.showSpinner(this);
    if (_.isEmpty(window.userInfo)) {
      await UserService.GetUserInfoForce();
    }
    const permittedRoleNames: string[] = [
      "_SystemAdmin",
      "BozkurtlarPersonel",
      "BozkurtlarAdmin",
    ];
    const userInfo = window.userInfo as IUserInfoDto;
    const userRoleNames = userInfo.roles.map((role) => role.name);
    if (
      !permittedRoleNames.some((roleName) => userRoleNames.includes(roleName))
    ) {
      await ReactSystemFunctions.goBack(this);

      const language = localStorage.getItem("ml");
      let permissonErrorMessageText =
        "You do not have permission to access this page.";
      if (language === "tr_TR") {
        permissonErrorMessageText = "Bu sayfaya erişim yetkiniz yok.";
      } else if (language === "fr_FR") {
        permissonErrorMessageText =
          "Vous n'avez pas la permission d'accéder à cette page.";
      } else if (language === "de_DE") {
        permissonErrorMessageText =
          "Sie haben keine Berechtigung, auf diese Seite zuzugreifen.";
      } else if (language === "es_ES") {
        permissonErrorMessageText =
          "No tienes permiso para acceder a esta página.";
      }

      KMainFunctions.displayErrorNotification(permissonErrorMessageText);
      state.isPageVisible = false;
      KuikaAppManager.hideSpinner(this);
      return;
    }
    state.isPageVisible = true;
    KuikaAppManager.hideSpinner(this);
  };

  componentDidUpdate = async (prevProps, prevState) => {
    KuikaAppManager.calculateAndSetBodyHeight("homepage", "header2_screen");
    if (prevProps?.location?.search !== (this.props as any)?.location?.search) {
      await this.HomePagePageInit();
    }

    if (
      this._prevMasterPageInitLoaded !== this.context.isMasterPageInitLoaded &&
      this.context.isMasterPageInitLoaded === true
    ) {
      this._prevMasterPageInitLoaded = this.context.isMasterPageInitLoaded;
      await this.HomePagePageInit();
    }

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      for (const key in prevState) {
        if (
          key.startsWith("NavVisible") &&
          prevState[key] === true &&
          this.state[key] === false
        ) {
          window.parentScreen = this;
          break;
        }
      }
    }
  };

  fillFormInitValues() {
    this.props.form?.setFieldsValue({});
  }

  setPageInitLoaded = (value: boolean) => {
    this.setState({ isPageInitLoaded: value });
  };

  setPageRecurringLoaded = (value: boolean) => {
    this.setState({ isPageRecurringLoaded: value });
  };

  clearFieldValidation = (changedValues: any) => {
    const fieldName = Object.keys(changedValues)[0];
    if (fieldName) {
      this.props.form?.setFields([
        {
          name: fieldName,
          errors: [],
        },
      ]);
    }
  };

  HomePagePageInit = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    let localVar = {
      KUserId_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.getMyUserId(),
        "Guid"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "HomePage/HomePagePageInit",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.HomePageOrderCount = result?.data.homePageOrderCount;
    formVars.homepage_669580_value = ReactSystemFunctions.toString(
      this,
      stateVars.HomePageOrderCount !== undefined
        ? stateVars.HomePageOrderCount?.length > 0
          ? stateVars.HomePageOrderCount[0].completedOrderCount
          : null
        : this.state.HomePageOrderCount?.length > 0
        ? this.state.HomePageOrderCount[0].completedOrderCount
        : null
    );
    formVars.homepage_977207_value = ReactSystemFunctions.toString(
      this,
      stateVars.HomePageOrderCount !== undefined
        ? stateVars.HomePageOrderCount?.length > 0
          ? stateVars.HomePageOrderCount[0].activeOrderCount
          : null
        : this.state.HomePageOrderCount?.length > 0
        ? this.state.HomePageOrderCount[0].activeOrderCount
        : null
    );
    formVars.homepage_351707_value = ReactSystemFunctions.toString(
      this,
      stateVars.HomePageOrderCount !== undefined
        ? stateVars.HomePageOrderCount?.length > 0
          ? stateVars.HomePageOrderCount[0].cancelledOrderCount
          : null
        : this.state.HomePageOrderCount?.length > 0
        ? this.state.HomePageOrderCount[0].cancelledOrderCount
        : null
    );
    stateVars.HomePageTop5 = result?.data.homePageTop5;

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.HomePagePageInit1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  HomePagePageInit1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    formVars.homepage_669580_value = ReactSystemFunctions.toString(
      this,
      stateVars.HomePageOrderCount !== undefined
        ? stateVars.HomePageOrderCount?.length > 0
          ? stateVars.HomePageOrderCount[0].completedOrderCount
          : null
        : this.state.HomePageOrderCount?.length > 0
        ? this.state.HomePageOrderCount[0].completedOrderCount
        : null
    );

    formVars.homepage_977207_value = ReactSystemFunctions.toString(
      this,
      stateVars.HomePageOrderCount !== undefined
        ? stateVars.HomePageOrderCount?.length > 0
          ? stateVars.HomePageOrderCount[0].activeOrderCount
          : null
        : this.state.HomePageOrderCount?.length > 0
        ? this.state.HomePageOrderCount[0].activeOrderCount
        : null
    );

    formVars.homepage_351707_value = ReactSystemFunctions.toString(
      this,
      stateVars.HomePageOrderCount !== undefined
        ? stateVars.HomePageOrderCount?.length > 0
          ? stateVars.HomePageOrderCount[0].cancelledOrderCount
          : null
        : this.state.HomePageOrderCount?.length > 0
        ? this.state.HomePageOrderCount[0].cancelledOrderCount
        : null
    );

    stateVars.dataSource_13255 =
      stateVars.HomePageTop5 ?? this.state.HomePageTop5;
    stateVars.isComp4023Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(this, "homepage_13255_value", "hasStock"),
        ReactSystemFunctions.convertToTypeByName("1", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp565486Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(this, "homepage_13255_value", "hasStock"),
        ReactSystemFunctions.convertToTypeByName("0", "string")
      ) === true
        ? "visible"
        : "hidden";

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    this.setPageInitLoaded(true);
    return isErrorOccurred;
  };

  HomePageComponent_381549_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    const __currentPath = (
      window.location.hash
        ? window.location.hash.replace(/^#/, "").split("?")[0]
        : window.location.pathname.split("?")[0]
    ).toLowerCase();
    if (__currentPath !== "/customerselect") {
      this.context.setMasterPageInitLoaded(false);
      this.context.setMasterPageRecurringLoaded(false);
      this.context.setShouldTriggerPageInit(true);
    }
    KuikaAppManager.prepareForNavigation();

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "HomePage",
      "CustomerSelect",
      "",
      "currentPage",
      null,
      null,
      null,
      null,
      null,
      null,
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  async callCallbackFunction(diId: number, isFromMaster: boolean = false) {
    let isErrorOccurred = false;
    let pageInitCallerNavDiIDs = [] as number[];
    if (isFromMaster || pageInitCallerNavDiIDs.indexOf(diId) > -1) {
      await this.HomePagePageInit();
    }
  }
}
